/**
 * Контур зоны действия отряда (см. configs/fieldRangeZone). Только расчет: рисует
 * scenes/FieldRangeZone.
 */

const pointKey = ({x, y}) => `${Math.round(x * 4)}_${Math.round(y * 4)}`;

/**
 * Стороны ячеек зоны, за которыми зоны уже нет: и внешняя граница, и края дыр за препятствиями
 *
 * @param {Array<{hex: Object, distance: number}>} cells — ячейки зоны и их расстояние от отряда
 * @returns {Array<{from: Object, to: Object, distance: number}>}
 */
export const buildZoneContourEdges = (cells) => {
  const edges = new Map();
  cells.forEach(({hex, distance}) => {
    hex.points.forEach((from, index) => {
      const to = hex.points[(index + 1) % hex.points.length];
      const fromKey = pointKey(from);
      const toKey = pointKey(to);
      const edgeKey = fromKey < toKey ? `${fromKey}|${toKey}` : `${toKey}|${fromKey}`;
      if (edges.has(edgeKey)) {
        // Общая сторона двух ячеек зоны — внутри нее, контура здесь нет
        edges.set(edgeKey, null);
      } else {
        edges.set(edgeKey, {from, to, distance});
      }
    });
  });
  return [...edges.values()].filter(Boolean);
};

/**
 * Стороны контура, собранные в замкнутые ломаные: по ним бегут огоньки. Вершины всех ячеек
 * обходятся в одну сторону, поэтому каждая сторона продолжает предыдущую
 *
 * @param {Array<{from: Object, to: Object}>} edges
 * @returns {Array<Array<{x: number, y: number}>>} последняя точка повторяет первую
 */
export const buildZoneContourLoops = (edges) => {
  const edgesByStart = new Map();
  edges.forEach((edge) => {
    const key = pointKey(edge.from);
    edgesByStart.set(key, [...(edgesByStart.get(key) || []), edge]);
  });

  const used = new Set();
  const loops = [];
  edges.forEach((firstEdge) => {
    if (used.has(firstEdge)) {
      return;
    }
    const points = [firstEdge.from];
    let edge = firstEdge;
    while (edge) {
      used.add(edge);
      points.push(edge.to);
      edge = (edgesByStart.get(pointKey(edge.to)) || []).find((candidate) => !used.has(candidate));
    }
    loops.push(points);
  });
  return loops;
};
